import apiClient from "@/api/client";

export interface CreateUserPayload {
  email: string;
  username: string;
  first_name?: string;
  last_name?: string;
  tenant_id: number;
  temporary_password: string;
  enabled?: boolean;
}

export interface CreateUserResponse {
  user_id: string;
  username: string;
  email: string;
  tenant_id: number;
  keycloak_group_id: string;
}

export interface TenantUser {
  id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  enabled: boolean;
}

export interface ListUsersResponse {
  tenant_id: number;
  tenant_name: string;
  keycloak_group_id: string | null;
  users: TenantUser[];
}

export async function createTenantUser(
  payload: CreateUserPayload,
): Promise<CreateUserResponse> {
  const { data } = await apiClient.post<CreateUserResponse>(
    "/admin/users",
    payload,
  );
  return data;
}

export async function listTenantUsers(
  tenantId: number,
): Promise<ListUsersResponse> {
  const { data } = await apiClient.get<ListUsersResponse>(
    `/admin/users/${tenantId}`,
  );
  return data;
}

export async function deleteUser(userId: string): Promise<{ status: string }> {
  const { data } = await apiClient.delete<{ status: string }>(
    `/admin/users/user/${userId}`,
  );
  return data;
}

export async function setUserEnabled(
  userId: string,
  enabled: boolean,
): Promise<{ user_id: string; enabled: boolean }> {
  const { data } = await apiClient.patch<{ user_id: string; enabled: boolean }>(
    `/admin/users/user/${userId}/enabled`,
    { enabled },
  );
  return data;
}

export async function resetUserPassword(
  userId: string,
  temporaryPassword: string,
): Promise<{ user_id: string; status: string }> {
  const { data } = await apiClient.patch<{
    user_id: string;
    status: string;
  }>(`/admin/users/user/${userId}/password`, {
    temporary_password: temporaryPassword,
  });
  return data;
}
